import React from 'react';

const Approach: React.FC = () => {
  const approaches = [
    {
      id: 1,
      title: 'お客様第一主義',
      description: 'お客様のニーズを深く理解し、最適なソリューションを提案します。コミュニケーションを大切にし、信頼関係を築きます。',
      icon: 'ri-user-heart-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20purple%20violet%20flowing%20lines%20representing%20connection%20trust%20collaboration%20elegant%20modern%20design%20smooth%20curves%20sophisticated%20atmosphere%20professional%20concept%20no%20people&width=600&height=400&seq=approach-connection-3201&orientation=landscape'
    },
    {
      id: 2,
      title: 'クリエイティブな発想',
      description: '常識にとらわれない自由な発想で、独創的なコンテンツを生み出します。トレンドを取り入れながら、オリジナリティを追求します。',
      icon: 'ri-lightbulb-flash-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20creative%20purple%20violet%20colorful%20explosion%20of%20ideas%20artistic%20geometric%20shapes%20modern%20design%20innovative%20concept%20sophisticated%20atmosphere%20professional%20no%20people&width=600&height=400&seq=approach-creative-ideas-3202&orientation=landscape'
    },
    {
      id: 3,
      title: '最新技術の活用',
      description: 'AI、機械学習、クラウドなど、最新のテクノロジーを積極的に導入。効率的で高品質なサービスを提供します。',
      icon: 'ri-cpu-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20purple%20violet%20digital%20technology%20circuit%20board%20patterns%20AI%20neural%20network%20visualization%20modern%20sophisticated%20design%20professional%20atmosphere%20no%20people&width=600&height=400&seq=approach-technology-3203&orientation=landscape'
    },
    {
      id: 4,
      title: 'スピーディーな対応',
      description: '迅速な意思決定と柔軟な対応で、お客様のビジネススピードに合わせたサービスを提供します。',
      icon: 'ri-rocket-line',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20purple%20violet%20motion%20blur%20speed%20lines%20energy%20flow%20modern%20design%20fast%20movement%20sophisticated%20atmosphere%20professional%20concept%20no%20people&width=600&height=400&seq=approach-speed-3204&orientation=landscape'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-white to-purple-50 relative overflow-hidden" id="approach">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-fuchsia-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-purple-900 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6 px-8 py-3 bg-gradient-to-r from-purple-900 to-violet-900 rounded-full border-2 border-fuchsia-400">
            <span className="text-purple-100 text-sm font-black tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
              OUR APPROACH
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-purple-900 mb-6" style={{ fontFamily: '"Shippori Mincho", serif' }}>
            私たちのアプローチ
          </h2>
          <p className="text-xl text-stone-700 max-w-3xl mx-auto leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
            4つの柱で、お客様のビジネスを成功へと導きます
          </p>
        </div>

        {/* 独創的な円形レイアウト */}
        <div className="relative max-w-5xl mx-auto">
          {/* 中央の装飾 */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-br from-fuchsia-400/20 to-violet-500/20 rounded-full blur-3xl"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {approaches.map((approach, index) => (
              <div 
                key={approach.id}
                className="group relative"
              >
                <div className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 border-2 border-purple-100 hover:border-fuchsia-400 hover:-translate-y-2">
                  {/* 画像部分 */}
                  <div className="h-56 overflow-hidden relative">
                    <img 
                      src={approach.image} 
                      alt={approach.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-purple-900/50 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-500"></div>
                    
                    {/* アイコン */}
                    <div className="absolute top-6 left-6">
                      <div className="w-16 h-16 bg-gradient-to-br from-fuchsia-400 to-violet-500 rounded-2xl flex items-center justify-center border-4 border-white/30 shadow-2xl">
                        <i className={`${approach.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
                      </div>
                    </div>

                    {/* 番号 */}
                    <div className="absolute bottom-6 right-6">
                      <div className="w-12 h-12 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center">
                        <span className="text-2xl font-black text-purple-900" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                          {String(approach.id).padStart(2, '0')}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* テキスト部分 */}
                  <div className="p-8">
                    <h3 className="text-2xl font-black text-purple-900 mb-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                      {approach.title}
                    </h3>
                    <p className="text-stone-700 leading-relaxed font-bold" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                      {approach.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;
